import { QueryLayerServiceInfoDc } from "@evergis/api";
import React, { FC, useMemo, useState } from "react";
import { ButtonsGroup, IButtonItemProps, useDialogShadow } from "@evergis/ui";
import { useTranslation } from "react-i18next";
import { useDialogInfo } from "../../../../../hooks/useDialogs";
import { LayerInfo } from "../../../../../interfaces/resourceInfo";
import { layer } from "../../../../../resources/layers";
import { LayerReferencesProvider } from "../../../DialogComponents/Attributes/LayerReferences/LayerReferencesProvider";
import { DialogContextProvider } from "../../../DialogComponents/FullScreenDialog";
import { StyledDialog } from "../../../DialogComponents/styled";

import { StyledDialogTitle } from "../Project/styled";
import { useContext } from "../Layer/hooks/useContext";
import { QueryLayerEdit } from "./QueryLayerEdit";
import { LayerResourceMode } from "./types";

export const QueryLayerResource: FC = () => {
  const {
    resources: [layerName],
    closeDialog,
  } = useDialogInfo(true);
  const { data } = layer.use({ input: layerName, waitInput: true });
  const context = useContext();
  const dialogShadow = useDialogShadow();
  const { shadows } = dialogShadow;

  const { t } = useTranslation();

  const modeOptions = useMemo(
    (): IButtonItemProps[] => [
      {
        value: LayerResourceMode.Info,
        label: t("information", { ns: "common" }),
      },
      {
        value: LayerResourceMode.Attributes,
        label: t("editResource.attributes", { ns: "dialogs" }),
      },
      {
        value: LayerResourceMode.RelatedData,
        label: t("editResource.relatedData", { ns: "dialogs" }),
      },
    ],
    [t],
  );

  const [selectedMode, setSelectedMode] = useState<IButtonItemProps>(modeOptions[0]);

  return (
    <StyledDialog
      isOpen
      modal
      onCloseRequest={closeDialog}
      minWidth={"58rem"}
      maxWidth={"58rem"}
      minHeight={"calc(100% - 6rem)"}
    >
      <DialogContextProvider dialogContext={context}>
        <StyledDialogTitle
          extraTitle={<ButtonsGroup options={modeOptions} selected={selectedMode} onClick={setSelectedMode} />}
          displayShadow={shadows.upper}
        />
        {data && (
          <LayerReferencesProvider layer={data as LayerInfo}>
            <QueryLayerEdit mode={selectedMode.value as LayerResourceMode} layer={data as QueryLayerServiceInfoDc} />
          </LayerReferencesProvider>
        )}
      </DialogContextProvider>
    </StyledDialog>
  );
};
